import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

import { AlertService } from "../../services/alert/alert.service";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { pharmacy } from '../../models/domain/pharmacy';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class PharmacyService extends DomainService {

  constructor(http: HttpClient,
    alertSvc: AlertService,
    loginSvc: LoginService) {

    super(http, alertSvc, loginSvc);
  }

  insertPharmacy(pharm: pharmacy, members: string): Observable<any> {
    if (Iceutility.isdefined(pharm) == false) throw "Pharmacy service Insert pharmacy has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Pharmacy service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/pharmacies/default.aspx?domain=&data=addpharmacy&key=&subkeys=" + "members:" + (members == null ? "" : members);
    let tblname = pharm.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pharm) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PHARMACY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  updatePharmacy(pharm: pharmacy): Observable<any> {
    if (Iceutility.isdefined(pharm) == false) throw "Pharmacy service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Pharmacy service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/pharmacies/default.aspx?domain=" + pharm.trans_account + "&data=updatepharmacy&key=&subkeys=domaintype:;lastname:";
    let tblname = pharm.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pharm) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PHARMACY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getPharmacies(): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Pharmacy service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/pharmacies/default.aspx?domain=&data=&key=&subkeys=";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PHARMACY_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }
}
